import { create } from "zustand";
import { getAgentCallingData, getAgentFeedback, getUserProfile } from "../api";
import { persist } from "zustand/middleware";

export const useUserProfile = create(
  persist(
    (set, get) => ({
      profileData: "",
      isLoading: false,
      isError: false,
      errorMessage: "",
      fetchProfileDetails: async () => {
        const state = get();
        if(isEmpty(state.profileData)){
          try {
            set({ isLoading: true });
            const response = await getUserProfile();
            set({ profileData: response?.data, isLoading: false });
          } catch (error) {
            set({
              isError: true, isLoading: false,
              errorMessage: error?.response?.data?.message || "Failed to fetch profile data.",
  
            });
          }
        }
      },
    }),
    {
      name: "user-profile-store",
      partialize: (state) => ({ profileData: state.profileData }), // Persist only `profileData`
    }
  )
);

export const useAgentCall = create((set) => ({
  agentCallData: {},
  agentFeedbackData:{},
  isLoading: false,
  isError: false,
  errorMEssage: "",
  fetchAgentCall: async () => {
    set({ isLoading: true });
    try {
      const response = await getAgentCallingData();
      set({ agentCallData: response?.data });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
      });
    } finally {
      set({ isLoading: false });
    }
  },
  fetchAgentFeedback: async () => {
    set({ isLoading: true });
    try {
      const response = await getAgentFeedback();
      set({ agentFeedbackData: response?.data });
    } catch (error) {
      set({
        isError: true,
        errorMessage: error?.response?.data?.message,
      });
    } finally {
      set({ isLoading: false });
    }
  },
}));

export const useCallingStore = create((set) => ({
  voitekkCalling: false,
  exotelCalling: false,
  knowlarityCalling: false,
  exotelAmeyoCalling: false,
  agamiCalling: false,
  ubonaCalling: false,
  updateCallingStatus: (callType, data) => {
    console.log({ [callType]: data });
    set({ [callType]: data });
  },
  disposeAllCalls: () => {
    set({
      voitekkCalling: false,
      exotelCalling: false,
      knowlarityCalling: false,
      exotelAmeyoCalling: false,
      agamiCalling: false,
      ubonaCalling: false,
    });
  },
}));
